import { AmericanFootball } from '@ps/isp-web-component-library/icons/AmericanFootball';
import { Athletics } from '@ps/isp-web-component-library/icons/Athletics';
import { AustralianRules } from '@ps/isp-web-component-library/icons/AustralianRules';
import { Badminton } from '@ps/isp-web-component-library/icons/Badminton';
import { Baseball } from '@ps/isp-web-component-library/icons/Baseball';
import { Basketball } from '@ps/isp-web-component-library/icons/Basketball';
import { Bowls } from '@ps/isp-web-component-library/icons/Bowls';
import { Boxing } from '@ps/isp-web-component-library/icons/Boxing';
import { Cricket } from '@ps/isp-web-component-library/icons/Cricket';
import { Curling } from '@ps/isp-web-component-library/icons/Curling';
import { Cycling } from '@ps/isp-web-component-library/icons/Cycling';
import { Darts } from '@ps/isp-web-component-library/icons/Darts';
import { Diving } from '@ps/isp-web-component-library/icons/Diving';
import { Esports } from '@ps/isp-web-component-library/icons/Esports';
import { Football } from '@ps/isp-web-component-library/icons/Football';
import { Futsal } from '@ps/isp-web-component-library/icons/Futsal';
import { Golf } from '@ps/isp-web-component-library/icons/Golf';
import { Greyhounds } from '@ps/isp-web-component-library/icons/Greyhounds';
import { Gymnastics } from '@ps/isp-web-component-library/icons/Gymnastics';
import { Handball } from '@ps/isp-web-component-library/icons/Handball';
import { Hockey } from '@ps/isp-web-component-library/icons/Hockey';
import { Horse } from '@ps/isp-web-component-library/icons/Horse';
import { IceHockey } from '@ps/isp-web-component-library/icons/IceHockey';
import { LineBeachVolleyball } from '@ps/isp-web-component-library/icons/LineBeachVolleyball';
import { MixedMartialArts } from '@ps/isp-web-component-library/icons/MixedMartialArts';
import { MotorRacing } from '@ps/isp-web-component-library/icons/MotorRacing';
import { Netball } from '@ps/isp-web-component-library/icons/Netball';
import { PokerFill } from '@ps/isp-web-component-library/icons/PokerFill';
import { Rowing } from '@ps/isp-web-component-library/icons/Rowing';
import { RugbyLeague } from '@ps/isp-web-component-library/icons/RugbyLeague';
import { RugbyUnion } from '@ps/isp-web-component-library/icons/RugbyUnion';
import { Shooting } from '@ps/isp-web-component-library/icons/Shooting';
import { Snooker } from '@ps/isp-web-component-library/icons/Snooker';
import { Specials } from '@ps/isp-web-component-library/icons/Specials';
import { Surfing } from '@ps/isp-web-component-library/icons/Surfing';
import { Swimming } from '@ps/isp-web-component-library/icons/Swimming';
import { TableTennis } from '@ps/isp-web-component-library/icons/TableTennis';
import { Tennis } from '@ps/isp-web-component-library/icons/Tennis';
import { Triathlon } from '@ps/isp-web-component-library/icons/Triathlon';
import { Trophy } from '@ps/isp-web-component-library/icons/Trophy';
import { Volleyball } from '@ps/isp-web-component-library/icons/Volleyball';
import { WaterPolo } from '@ps/isp-web-component-library/icons/WaterPolo';
import { Weightlifting } from '@ps/isp-web-component-library/icons/Weightlifting';
import { WinterOlympics } from '@ps/isp-web-component-library/icons/WinterOlympics';
import { WinterSports } from '@ps/isp-web-component-library/icons/WinterSports';
import { Wrestling } from '@ps/isp-web-component-library/icons/Wrestling';

import { EventTypeId } from '@swf/sports/types/eventType';

const EventTypeIcons: Partial<Record<EventTypeId, React.ComponentType>> = {
  [EventTypeId.AMERICAN_FOOTBALL]: AmericanFootball,
  [EventTypeId.ATHLETICS]: Athletics,
  [EventTypeId.AUSTRALIAN_RULES]: AustralianRules,
  [EventTypeId.BADMINTON]: Badminton,
  [EventTypeId.BASKETBALL]: Basketball,
  [EventTypeId.BASEBALL]: Baseball,
  [EventTypeId.BEACH_VOLLEYBALL]: LineBeachVolleyball,
  [EventTypeId.BOWLS]: Bowls,
  [EventTypeId.BOXING]: Boxing,
  [EventTypeId.CRICKET]: Cricket,
  [EventTypeId.CYCLING]: Cycling,
  [EventTypeId.CURLING]: Curling,
  [EventTypeId.DARTS]: Darts,
  [EventTypeId.DIVING]: Diving,
  [EventTypeId.E_SPORTS]: Esports,
  [EventTypeId.FUTSAL]: Futsal,
  [EventTypeId.GREYHOUND_RACING]: Greyhounds,
  [EventTypeId.HANDBALL]: Handball,
  [EventTypeId.HOCKEY]: Hockey,
  [EventTypeId.HORSE_RACING]: Horse,
  [EventTypeId.ICE_HOCKEY]: IceHockey,
  [EventTypeId.GOLF]: Golf,
  [EventTypeId.GYMNASTICS]: Gymnastics,
  [EventTypeId.MOTOR_SPORT]: MotorRacing,
  [EventTypeId.NETBALL]: Netball,
  [EventTypeId.POKER]: PokerFill,
  [EventTypeId.RUGBY_LEAGUE]: RugbyLeague,
  [EventTypeId.RUGBY_UNION]: RugbyUnion,
  [EventTypeId.ROWING]: Rowing,
  [EventTypeId.SHOOTING]: Shooting,
  [EventTypeId.SOCCER]: Football,
  [EventTypeId.SPECIAL_BETS]: Specials,
  [EventTypeId.SNOOKER]: Snooker,
  [EventTypeId.SWIMMING]: Swimming,
  [EventTypeId.TABLE_TENNIS]: TableTennis,
  [EventTypeId.TENNIS]: Tennis,
  [EventTypeId.TRIATHLON]: Triathlon,
  [EventTypeId.SURFING]: Surfing,
  [EventTypeId.VOLLEYBALL]: Volleyball,
  [EventTypeId.WATER_POLO]: WaterPolo,
  [EventTypeId.MIXED_MARTIAL_ARTS]: MixedMartialArts,
  [EventTypeId.WEIGHTLIFTING]: Weightlifting,
  [EventTypeId.WINTER_SPORTS]: WinterSports,
  [EventTypeId.WINTER_OLYMPICS]: WinterOlympics,
  [EventTypeId.WRESTLING]: Wrestling
};

/**
 * Gets the icon name for the event types, if there's no icon for specified event type,
 * it returns the 'trophy' icon.
 * @example EventTypeId.WINTER_OLYMPICS
 * returns 'winter-olympics'
 * @example EventTypeId.LOTTERIES
 * returns 'trophy'
 */
export const getEventTypeIcon = (eventType?: EventTypeId): React.ComponentType =>
  eventType ? EventTypeIcons[eventType] ?? Trophy : Trophy;
